import * as types from './quizzActionTypes';
import { firebase } from './../../utils/firebase/firebase';

import { push } from 'react-router-redux';

var getQuizzDataSuccess = function getQuizzDataSuccess(quizzId, quizzName, nbSteps, step) {
    return {
        type: types.GET_QUIZZ_DATA_SUCCESS,
        quizzId: quizzId,
        quizzName: quizzName,
        nbSteps: nbSteps,
        step: step
    };
};

var getQuizzDataError = function getQuizzDataError(errorMessage) {
    return {
        type: types.GET_QUIZZ_DATA_ERROR,
        errorMessage: errorMessage
    };
};

export var getQuizzData = function getQuizzData(quizzId) {
    return function (dispatch, getState) {
        firebase.firebaseApp.database().ref('quizz/' + quizzId).once('value').then(function (snapshot) {
            var quizzName = snapshot.val() && snapshot.val().quizzName || '';
            var steps = snapshot.val() && snapshot.val().steps || [];
            var nbSteps = steps.length;

            // when user has already answered before, and because data retrieved from the history contains only the last question answered, 
            // we need to update the step accordingly
            var step = getState().quizz.previousUserAnswers.hasOwnProperty(quizzId) ? nbSteps - 1 : 0;

            dispatch(getQuizzDataSuccess(quizzId, quizzName, nbSteps, step));
            dispatch(getQuestionData(quizzId, step));
        }).catch(function (err) {
            dispatch(getQuizzDataError(err));
        });
    };
};

export var getQuestionSuccess = function getQuestionSuccess(quizzId, question, answers, questionType) {
    return {
        type: types.GET_QUESTION_SUCCESS,
        question: question,
        answers: answers,
        questionType: questionType,
        quizzId: quizzId
    };
};

export var getQuestionError = function getQuestionError(errorMessage) {
    return {
        type: types.GET_QUESTION_ERROR,
        errorMessage: errorMessage
    };
};

export var getQuestionData = function getQuestionData(quizzId, step) {
    return function (dispatch) {
        firebase.firebaseApp.database().ref('quizz/' + quizzId + '/steps/' + step).once('value').then(function (snapshot) {
            var question = snapshot.val() && snapshot.val().question || '';
            var answers = snapshot.val() && snapshot.val().answers || [];
            var questionType = snapshot.val() && snapshot.val().type || 'single';

            for (var i = 0; i < answers.length; i++) {
                answers[i] = answers[i]["answer"];
            }
            dispatch(getQuestionSuccess(quizzId, question, answers, questionType));
        }).catch(function (err) {
            dispatch(getQuestionError(err));
        });
    };
};

export var resultSuccess = function resultSuccess(userAnswers, isValid, correctAnswers) {
    return {
        type: types.RESULT_SUCCESS,
        isValid: isValid,
        correctAnswers: correctAnswers,
        currentUserAnswers: userAnswers
    };
};

export var resultError = function resultError(errorMessage) {
    return {
        type: types.RESULT_ERROR,
        isValid: isValid
    };
};

export var checkResult = function checkResult(userAnswers, quizzId, step) {
    return function (dispatch) {
        var isValid = true;

        firebase.firebaseApp.database().ref('quizz/' + quizzId + '/steps/' + step).once('value').then(function (snapshot) {
            var answers = snapshot.val() && snapshot.val().answers || [];
            var correctAnswers = [];
            var userAnswersValues = [];

            if (userAnswers.length === 0) {
                // when user do not select any answer and submit the quizz form, we return an empty correctAnswer array
                isValid = false;
            } else {
                // when user has made a choice and we make sure that this is correct or not
                for (var i = 0; i < answers.length; i++) {
                    if (answers[i].isValid) {
                        correctAnswers.push(answers[i].answer);
                    }
                    if (userAnswers[i] === true) {
                        userAnswersValues.push(i);
                    }
                    if (userAnswers[i] !== answers[i].isValid) {
                        isValid = false;
                    }
                }
            }

            dispatch(resultSuccess(userAnswersValues, isValid, correctAnswers));
        }).catch(function (err) {
            dispatch(getQuestionError(err));
        });
    };
};

var nextStep = function nextStep(quizzId) {
    return {
        type: types.NEXT_STEP,
        quizzId: quizzId
    };
};

var hideModal = function hideModal(quizzId) {
    return {
        type: types.HIDE_MODAL,
        quizzId: quizzId
    };
};

export var completeStep = function completeStep(quizzId) {
    return {
        type: types.COMPLETED_STEP,
        quizzId: quizzId
    };
};

var endQuizz = function endQuizz(payload) {
    //payload is only used by the action logger middleware
    return {
        type: types.END_QUIZZ,
        payload: payload
    };
};

export var closeModal = function closeModal(quizzId) {
    return function (dispatch, getState) {
        //const quizz = getState().quizz;

        var currentQuizzId = quizzId !== '' ? quizzId : '';
        var quizzList = getState().quizz.articleQuizzes;

        if (Object.keys(quizzList).length > 0 && currentQuizzId !== '' && quizzList.hasOwnProperty(currentQuizzId)) {
            var quizzData = quizzList[currentQuizzId];
            var currentStep = quizzData.quizzStep;
            var totalStep = quizzData.totalQuizzStep;
            var quizzAnswers = quizzData.quizzAnswers;
            var quizzGoodAnswers = quizzData.quizzGoodAnswers;
            var isValidAnswer = quizzData.quizzAnswerIsValid; // validation here is based only on the last question

            if (!isValidAnswer && quizzGoodAnswers.length === 0) {
                dispatch(hideModal(currentQuizzId));
            } else if (currentStep < totalStep - 1) {

                dispatch(nextStep(currentQuizzId));
                dispatch(getQuestionData(currentQuizzId, currentStep + 1));
            } else {

                // check answer validity
                var validityMapping = [];
                for (var j = 0; j < quizzAnswers.length; j++) {
                    for (var i = 0; i <= quizzGoodAnswers.length; i++) {
                        if (quizzAnswers[j] === quizzGoodAnswers[i]) {
                            validityMapping.push(j);
                        }
                    }
                }

                var payload = { action: 'answer',
                    entityId: currentQuizzId,
                    entityValue: quizzData.quizzName,
                    value: quizzData.quizzUserAnswers.join(',') + '-' + validityMapping.join(','),
                    point: false
                };
                //if there's error in the answers, we send 0 point
                if (!isValidAnswer) {
                    payload.point = 0;
                }

                dispatch(endQuizz(payload));
            }
        }
    };
};

export var setUserPreviousAnswsers = function setUserPreviousAnswsers(quizzId, answers) {
    return {
        type: types.SET_USER_PREVIOUS_ANSWERS,
        quizzId: quizzId,
        answers: answers
    };
};

export var resetQuizz = function resetQuizz(quizzId) {
    return {
        type: types.RESET_QUIZZ,
        quizzId: quizzId
    };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-quiz/es/components/Quizz/quizzActions.js
// module id = 41
// module chunks = 0